import * as actionTypes from '../../constants/actionTypes';
import { DELETE, GET, POST, PUT } from 'js/constants/requestMethods';
import { CALL_PRIVATE_API } from 'js/middleware/api';
import { sdkApplicationSchema } from 'js/schemas/sdkApplication';
import { addProcess, removeProcess } from 'js/actions';
import {
  DELETE_SDK_APPLICATION,
  PAUSE_SDK_APPLICATION,
  ACTIVATE_SDK_APPLICATION,
} from 'js/constants/processTypes';

export function fetchSdkApplication(id: number) {
  return (dispatch: any) => {
    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          actionTypes.GET_SDK_APPLICATION_REQUEST,
          actionTypes.GET_SDK_APPLICATION_SUCCESS,
          actionTypes.GET_SDK_APPLICATION_FAILURE,
        ],
        endpoint: `/sdk_applications/${id}`,
        schema: sdkApplicationSchema,
        requestMethod: GET,
        requestInfo: {},
        ignoreErrors: true,
      },
    });
  };
}

export function fetchAllSdkApplications() {
  return (dispatch: any) => {
    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          actionTypes.GET_ALL_SDK_APPLICATIONS_REQUEST,
          actionTypes.GET_ALL_SDK_APPLICATIONS_SUCCESS,
          actionTypes.GET_ALL_SDK_APPLICATIONS_FAILURE,
        ],
        endpoint: '/sdk_applications',
        schema: [sdkApplicationSchema],
        requestMethod: GET,
        requestInfo: {},
      },
    });
  };
}

export type CreateSdkApplicationPayload = {
  name: string;
  description: string;
  allowed_origins: string[];
};

export function createSdkApplication(data: CreateSdkApplicationPayload) {
  return (dispatch: any) => {
    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          actionTypes.CREATE_SDK_APPLICATION_REQUEST,
          actionTypes.CREATE_SDK_APPLICATION_SUCCESS,
          actionTypes.CREATE_SDK_APPLICATION_FAILURE,
        ],
        endpoint: '/sdk_applications',
        schema: sdkApplicationSchema,
        requestMethod: POST,
        payload: data,
      },
    });
  };
}

export type UpdateSdkApplicationPayload = {
  name?: string;
  description?: string;
  allowed_origins?: string[];
};

export function updateSdkApplication(id: number, data: UpdateSdkApplicationPayload) {
  return (dispatch: any) => {
    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          actionTypes.UPDATE_SDK_APPLICATION_REQUEST,
          actionTypes.UPDATE_SDK_APPLICATION_SUCCESS,
          actionTypes.UPDATE_SDK_APPLICATION_FAILURE,
        ],
        endpoint: `/sdk_applications/${id}`,
        schema: sdkApplicationSchema,
        requestMethod: PUT,
        payload: data,
        requestInfo: {},
      },
    });
  };
}

export function deleteSdkApplication(id: number) {
  return (dispatch: any) => {
    dispatch(addProcess(DELETE_SDK_APPLICATION, 'Deleting SDK Application', { id }));

    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          actionTypes.DELETE_SDK_APPLICATION_REQUEST,
          actionTypes.DELETE_SDK_APPLICATION_SUCCESS,
          actionTypes.DELETE_SDK_APPLICATION_FAILURE,
        ],
        endpoint: `/sdk_applications/${id}`,
        requestMethod: DELETE,
        requestInfo: { id },
      },
    }).finally(() => {
      dispatch(removeProcess(DELETE_SDK_APPLICATION, { id }));
    });
  };
}

export function pauseSdkApplication(id: number) {
  return (dispatch: any) => {
    dispatch(addProcess(PAUSE_SDK_APPLICATION, 'Pausing SDK Application', { id }));

    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          actionTypes.PAUSE_SDK_APPLICATION_REQUEST,
          actionTypes.PAUSE_SDK_APPLICATION_SUCCESS,
          actionTypes.PAUSE_SDK_APPLICATION_FAILURE,
        ],
        endpoint: `/sdk_applications/${id}/pause`,
        schema: sdkApplicationSchema,
        requestMethod: PUT,
        requestInfo: { id },
      },
    }).finally(() => {
      dispatch(removeProcess(PAUSE_SDK_APPLICATION, { id }));
    });
  };
}

export function activateSdkApplication(id: number) {
  return (dispatch: any) => {
    dispatch(addProcess(ACTIVATE_SDK_APPLICATION, 'Activating SDK Application', { id }));

    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          actionTypes.ACTIVATE_SDK_APPLICATION_REQUEST,
          actionTypes.ACTIVATE_SDK_APPLICATION_SUCCESS,
          actionTypes.ACTIVATE_SDK_APPLICATION_FAILURE,
        ],
        endpoint: `/sdk_applications/${id}/activate`,
        schema: sdkApplicationSchema,
        requestMethod: PUT,
        requestInfo: { id },
      },
    }).finally(() => {
      dispatch(removeProcess(ACTIVATE_SDK_APPLICATION, { id }));
    });
  };
}
